import { createContext } from "react";

const LanguageContext = createContext(null);
export default LanguageContext;
